import React, { useState, useEffect } from 'react';
import axios from 'axios';
import api from '../api';
import { useNavigate } from 'react-router-dom';

export default function AdminPanel() {
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const refreshAccessToken = async () => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');
      if (!refreshToken) {
        throw new Error('No refresh token');
      }
      const res = await api.post('/api/auth/refresh-token', { refreshToken });
      localStorage.setItem('authToken', res.data.accessToken);
      return res.data.accessToken;
    } catch (err) {
      if (err.response?.status !== 401 && localStorage.getItem('refreshToken')) throw err;
      localStorage.removeItem('authToken');
      localStorage.removeItem('refreshToken');
      navigate('/login_page');
      return null;
    }
  };

  useEffect(() => {
    if (!token) {
      navigate('/login_page');
      return;
    }
const fetchRequests = async () => {
    try {
      const res = await api.get('/api/wallet/requests', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRequests(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        const newToken = await refreshAccessToken();
        if (newToken) {
          // درخواست را با توکن جدید تکرار کنید
          const res = await api.get('/api/wallet/requests', {
            headers: { Authorization: `Bearer ${newToken}` },
          });
          setRequests(res.data);
        }
      } else {
        setError(err.response?.data?.message || 'خطا در دریافت درخواست‌ها');
      }
    }
  };
  fetchRequests();
}, [token, navigate]);

  const handleRequest = async (id, status, rejectReason) => {
    try {
      await api.put(
        `/api/wallet/requests/${id}`,
        { status, reject_reason: rejectReason },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setRequests(requests.filter((req) => req.id !== id));
      setSuccess(`درخواست ${status === 'approved' ? 'تأیید' : 'رد'} شد`);
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      if (err.response?.status === 401) {
        setError('جلسه شما منقضی شده است. لطفاً دوباره وارد شوید.');
        localStorage.removeItem('authToken');
        setTimeout(() => navigate('/login_page'), 2000);
      } else {
        setError(err.response?.data?.message || 'خطا در به‌روزرسانی');
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <h2 data-page-title="true" className="text-2xl font-bold text-gray-800 mb-6">پنل مدیر</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        {success && <p className="text-green-500 mb-4">{success}</p>}
        {requests.length === 0 ? (
          <p className="text-gray-500">هیچ درخواستی در انتظار نیست</p>
        ) : (
          <table className="min-w-full bg-white rounded-xl shadow-lg">
            <thead>
              <tr>
                <th className="py-3 px-4 border-b text-right">کاربر</th>
                <th className="py-3 px-4 border-b text-right">نوع</th>
                <th className="py-3 px-4 border-b text-right">مبلغ (ریال)</th>
                <th className="py-3 px-4 border-b text-right">فیش</th>
                <th className="py-3 px-4 border-b text-right">حساب بانکی</th>
                <th className="py-3 px-4 border-b text-right">عملیات</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req) => (
                <tr key={req.id}>
                  <td className="py-3 px-4 border-b">{req.first_name} {req.last_name}</td>
                  <td className="py-3 px-4 border-b">{req.type === 'deposit' ? 'شارژ' : 'برداشت'}</td>
                  <td className="py-3 px-4 border-b">{req.amount.toLocaleString()}</td>
                  <td className="py-3 px-4 border-b">
                    {req.receipt_image ? (
                      <a href={req.receipt_image} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                        مشاهده
                      </a>
                    ) : '—'}
                  </td>
                  <td className="py-3 px-4 border-b">{req.bank_account_id || '—'}</td>
                  <td className="py-3 px-4 border-b flex space-x-2">
                    <button
                      onClick={() => handleRequest(req.id, 'approved')}
                      className="bg-green-500 text-white py-1 px-3 rounded hover:bg-green-600"
                    >
                      تأیید
                    </button>
                    <button
                      onClick={() => {
                        const reason = prompt('دلیل رد درخواست:');
                        if (reason) handleRequest(req.id, 'rejected', reason);
                      }}
                      className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-600"
                    >
                      رد
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}